import React from "react";
import PropTypes from "prop-types";
import { TagInput } from "@oxygen/core";
import CityAutocomplete from "./CityAutocomplete";
import AreaAutocomplete from "./AreaAutocomplete";
import { fireInteractiveTracking } from "GlobalUtils/Analytics";
import { platform as PLATFORM } from "GlobalEnum/Platform";

const propTypes = {
  // Pass object with city and area details
  cityLocation: PropTypes.shape({
    cityId: PropTypes.number.isRequired,
    cityName: PropTypes.string.isRequired,
    areaId: PropTypes.number.isRequired,
    areaName: PropTypes.string.isRequired,
  }).isRequired,
  // Callback function fired on city selection
  setCity: PropTypes.func,
  // Callback function fired on area selection
  setArea: PropTypes.func,
  // Callback function fired on city removal
  onCityRemove: PropTypes.func,
  // Callback function fired on area removal
  onAreaRemove: PropTypes.func,
  // Set clear button for input field
  setClearButton: PropTypes.bool,
  // Set focus on input field
  focus: PropTypes.bool,
  // gaTracking Label
  gaTrackingLabel: PropTypes.string,
  // city with areas
  citiesWithArea: PropTypes.arrayOf(PropTypes.number),
  //  platform
  platform: PropTypes.object,
};

const defaultProps = {
  focus: true,
  gaTrackingLabel: "",
  citiesWithArea: [],
  platform: PLATFORM.MOBILE,
};
/**
 * Location Selection render City, Area AutoComplete or
 * current selected City (and Area) as tags based on current stage
 * Location Selection
 */
class LocationSelection extends React.Component {
  constructor(props) {
    super(props);
  }

  handleCityInputFocus = () => {
    fireInteractiveTracking(
      "GlobalCityPopUp",
      "Tap_City_Box",
      this.props.gaTrackingLabel
    );
  };

  handleAreaInputFocus = () => {
    const { cityName } = this.props.cityLocation;
    const { gaTrackingLabel } = this.props;
    fireInteractiveTracking(
      "GlobalCityPopUp",
      "Tap_Area_Box",
      cityName + (gaTrackingLabel || "")
    );
  };
  renderInput = () => {
    const {
      cityLocation,
      citiesWithArea,
      setClearButton,
      focus,
      onCityRemove,
      setCity,
      setArea,
      inputRef,
      onClear,
      platform,
    } = this.props;
    const { cityId = -1, areaId = -1 } = cityLocation;
    if (cityId <= 0) {
      return (
        <CityAutocomplete
          inputRef={inputRef}
          cityLocation={cityLocation}
          setCity={setCity}
          platform={platform}
          setClearButton={setClearButton}
          onFocus={this.handleCityInputFocus}
          setFocus={focus}
          onClear={onClear}
        />
      );
    } else if (areaId <= 0 && citiesWithArea.indexOf(cityId) > -1) {
      return (
        <AreaAutocomplete
          platform={platform}
          inputRef={inputRef}
          cityLocation={cityLocation}
          removeCity={onCityRemove}
          setArea={setArea}
          setClearButton={setClearButton}
          onFocus={this.handleAreaInputFocus}
          setFocus={focus}
          onClear={onClear}
        />
      );
    }
    return null;
  };
  renderSelectedTags = () => {
    const { onCityRemove, onAreaRemove, cityLocation } = this.props;
    const { cityName, areaId = -1, areaName } = cityLocation;
    const selected = [{ text: cityName, handleClick: onCityRemove }];
    if (areaId > 0) {
      selected.push({ text: areaName, handleClick: onAreaRemove });
    }
    return (
      <TagInput
        hasCloseButton
        hasInput={false}
        selected={selected}
        data-testing-id="location"
      />
    );
  };
  render() {
    const { citiesWithArea, cityLocation } = this.props;
    const { cityId = -1, areaId = -1 } = cityLocation;
    const selectionRequired =
      cityId <= 0 || (areaId <= 0 && citiesWithArea.indexOf(cityId) > -1);
    return selectionRequired ? this.renderInput() : this.renderSelectedTags();
  }
}

LocationSelection.propTypes = propTypes;
LocationSelection.defaultProps = defaultProps;

export default LocationSelection;
